import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { environment } from '@app-environments/environment';
import { ExamService } from '@app-services/test/exam.service';

@Component({
  selector: 'app-confirm-edit-phone-number-dialog',
  templateUrl: './confirm-edit-phone-number-dialog.component.html',
  styleUrls: ['./confirm-edit-phone-number-dialog.component.css']
})
export class ConfirmEditPhoneNumberDialogComponent implements OnInit {
  examInfo:any;
  isScoreScatExam:boolean = false;
  scatHome = environment?.scatHome;
  constructor( @Inject(MAT_DIALOG_DATA) public data: any,
               private dialog: MatDialog,
               private dialogRef: MatDialogRef<ConfirmEditPhoneNumberDialogComponent>,
               public router: Router,
               private examService: ExamService) { 
                this.examInfo = this.examService.getPresentExamInfo();
                this.isScoreScatExam = this.examInfo?.source === 'scat' ? true : false;
               }

  ngOnInit(): void {
    // this.dialogRef.disableClose = true;
  }

  /**
   * To close all previously opened dialouges
   * @memberof ConfirmDialogComponent
   */
  onNoClick(): void {
    this.dialogRef.close(true);
  }

  /**
   * To close the dialog and confirm the cost file
   *
   * @memberof ConfirmDialogComponent
   */
  onConfirmClick(): void {
    const confirmStatus = true;
    this.dialogRef.close(confirmStatus);
  }

  backToScat(){
    window.open(this.scatHome,'_self')
  }

}
